import { useQuery } from '@tanstack/react-query';

import { metaKeys } from '../query-keys/meta';
import { useRepository } from '../repository-context';

export function useMetaQuery() {
  const repo = useRepository();
  return useQuery({
    queryKey: metaKeys.detail(),
    queryFn: () => repo.getMeta(),
    staleTime: 60_000,
  });
}
